var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_139_16036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.619 12.006H6.38C6.167 12.006 5.995 11.805 5.995 11.558C5.995 11.311 6.167 11.11 6.38 11.11L7 11V8L6.38 7.884C6.167 7.884 5.995 7.683 5.995 7.436C5.995 7.189 6.167 6.988 6.38 6.988H8.894C8.971 6.988 8.996 6.956 9.007 6.93C9.004 6.945 9 6.959 9 7V11L9.619 11.11C9.832 11.11 10.005 11.311 10.005 11.558C10.005 11.805 9.832 12.006 9.619 12.006ZM7 4H7.98C7.987 4 7.993 3.996 8 3.996C8.007 3.996 8.013 4 8.02 4H9V4.94C9.001 4.962 9.012 4.98 9.012 5.001C9.012 5.023 9.001 5.041 9 5.062V6H8.033C8.021 6.001 8.011 6.007 8 6.007C7.988 6.007 7.978 6.001 7.967 6H7V5.061C6.998 5.04 6.987 5.023 6.987 5.001C6.987 4.98 6.998 4.962 7 4.941V4ZM8 0C3.581 0 0 3.582 0 8C0 12.418 3.581 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_139_16036)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#1C2024"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3d17c1436c306251977dd50fe6398324.svg";
export { ForwardRef as ReactComponent };